@if ((loading$ | async) === false) {
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Компания</label>
            <crm-company-single-select
              [(selectedCompany)]="exclusion.company"
              [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-company-single-select>
            @if (errors?.company) {
              <small class="p-error">
                {{ errors.company | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium required-field">Контрагент</label>
            <crm-contragent-auto-complete
              [(selectedContragent)]="exclusion.contragent"
              [customSearch]="false"
              [isError]="$any(errors?.contragent)"
              appendTo="body">
            </crm-contragent-auto-complete>
            @if (errors?.contragent) {
              <small class="p-error">
                {{ errors.contragent | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium required-field">Сумма</label>
            <p-inputNumber
              [(ngModel)]="exclusion.amount"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.amount }"></p-inputNumber>
            @if (errors?.amount) {
              <small class="p-error">
                {{ errors.amount | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium">Дата отсрочки</label>
            <crm-datepicker
              [(value)]="exclusion.defermentGrantedUntil"
              [inputStyleClass]="errors?.defermentGrantedUntil ? 'ng-invalid ng-dirty' : ''"
              (valueChange)="delayDateMessage()"
              appendTo="body"></crm-datepicker>
            @if (errors?.defermentGrantedUntil) {
              <small class="p-error">
                {{ errors.defermentGrantedUntil | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium">Комментарий</label>
            <crm-editor
              [(value)]="exclusion.commentary"
              height="110px"></crm-editor>
            @if (errors?.commentary) {
              <small class="p-error">{{ errors.commentary | join }}</small>
            }
          </div>
          <div class="flex align-items-center justify-content-between">
            <crm-file-uploader
              label="Файл"
              (filesUploaded)="exclusion.file = $event[0]"></crm-file-uploader>
            @if (errors?.file) {
              <small class="p-error">
                {{ errors.file | join }}
              </small>
            }
            @if (exclusion.file) {
              <div class="flex align-items-center">
                <crm-document-link [file]="exclusion.file"></crm-document-link>
                <crm-button
                  type="button"
                  icon="pi pi-times"
                  styleClass="p-button-rounded p-button-danger p-button-text ml-3"
                  (onClick)="exclusion.file = null"></crm-button>
              </div>
            }
          </div>
        </div>
      </p-card>
    </div>

    @if (formStoreService.getState.forms[this.index]?.isEdit) {
      <div class="col-12 mt-3">
        <crm-exclusion-history [index]="index"></crm-exclusion-history>
      </div>
    }
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <div>
        <crm-button
          [label]="saveButtonLabel"
          styleClass="p-button-success mr-2"
          (onClick)="saveExclusion()"></crm-button>
      </div>
      @if ((form$ | async)?.isShowDelete) {
        <crm-button
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteExclusion()"></crm-button>
      }
    </div>
  </div>
} @else {
  <ng-template [ngTemplateOutlet]="loadingTemplate"></ng-template>
}

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
